import { SimpleGrid, Image } from "@mantine/core";

export default function KibbeMoodStrip({ type }: { type: string }) {
  const imageCount = 8;
  // Convert "Soft Gamine" -> "soft-gamine" to match public/kibbe/types/<slug>/
  const slug = type.toLowerCase().replace(/ /g, "-");
  const images = Array.from(
    { length: imageCount },
    (_, i) => `/kibbe/types/${slug}/${i + 1}.webp`,
  );

  return (
    <SimpleGrid cols={{ base: 2, md: 4 }} spacing={12} verticalSpacing={12} style={{ margin: "32px 0" }}>
      {images.map((src, idx) => (
        <Image
          key={src}
          src={src}
          alt={`${type} mood ${idx + 1}`}
          style={{ borderRadius: 8, objectFit: "cover", background: "#f8f8f8" }}
        />
      ))}
    </SimpleGrid>
  );
}
